var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link"},[(!_vm.external)?_c('router-link',{attrs:{"to":_vm.link}},[_vm._t("default")],2):(_vm.link)?_c('a',{attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer"}},[_vm._t("default")],2):_c('span',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }